import Vue from 'vue'
import VueRouter from 'vue-router'

import LoginView from '../views/LoginView.vue'
import IndexView from '../views/Back/IndexView.vue'
import MainView from '../views/Back/MainView.vue'

import AdminListView from '../views/Back/Admin/AdminListView.vue'
import PermissionListView from '../views/Back/Permission/PermissionListView.vue'
import RoleListView from '../views/Back/Role/RoleListView.vue'

import CategoryListView from '../views/Back/Category/CategoryListView.vue'
import CustomerListView from '../views/Back/Customer/CustomerListView.vue'

import PaymentUpPlanListView from '../views/Back/Payment/PaymentUpPlanListView.vue'
import PaymentUpActualListView from '../views/Back/Payment/PaymentUpActualListView.vue'
import PaymentDownPlanListView from '../views/Back/Payment/PaymentDownPlanListView.vue'
import PaymentDownActualListView from '../views/Back/Payment/PaymentDownActualListView.vue'
import PaymentSummaryView from '../views/Back/Payment/PaymentSummaryView.vue'

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

// 重写push方法
VueRouter.prototype.push = function(location) {
  return originalPush.call(this, location).catch(err => err);
};

// 重写replace方法
VueRouter.prototype.replace = function(location) {
  return originalReplace.call(this, location).catch(err => err);
};

Vue.use(VueRouter)

const routes = [
  {
    path: '/Login',
    name: 'LoginView',
    component: LoginView
  },
  {
    path: '/',
    name: 'IndexView',
    component: IndexView,
    children: [
      {
        path: '/Main',
        name: 'MainView',
        component: MainView
      },
      {
        path: '/Admin/List',
        name: 'AdminListView',
        component: AdminListView
      },
      {
        path: '/Permission/List',
        name: 'PermissionListView',
        component: PermissionListView
      },
      {
        path: '/Role/List',
        name: 'RoleListView',
        component: RoleListView
      },
      {
        path: '/Category/List',
        name: 'CategoryListView',
        component: CategoryListView
      },
      {
        path: '/Customer/List',
        name: 'CustomerListView',
        component: CustomerListView
      },
      {
        path: '/Payment/Up/PlanList',
        name: 'PaymentUpPlanListView',
        component: PaymentUpPlanListView
      },
      {
        path: '/Payment/Up/ActualList',
        name: 'PaymentUpActualListView',
        component: PaymentUpActualListView
      },
      {
        path: '/Payment/Down/PlanList',
        name: 'PaymentDownPlanListView',
        component: PaymentDownPlanListView
      },
      {
        path: '/Payment/Down/ActualList',
        name: 'PaymentDownActualListView',
        component: PaymentDownActualListView
      },
      {
        path: '/Payment/Summary',
        name: 'PaymentSummaryView',
        component: PaymentSummaryView
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
